export enum DocumentationMode {
  VIEW_ONLY = 'VIEW_ONLY',
  DOWNLOAD_ONLY = 'DOWNLOAD_ONLY',
  UPLOAD_ONLY = 'UPLOAD_ONLY',
  FULL = 'FULL',
}
